import React from 'react'
import {  TableRow, TableCell, Menu, MenuItem } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import dayjs from 'dayjs'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'

var classNames = require('classnames')

export const RefferedUserTableRows = ({user, onUserClick, options}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = (choice) => {
      setAnchorEl(null);
    };


    const onMenuItemClick = (option) => {
        handleClose();
        option.onClick();
    }

    return (

        <TableRow className="clickable" key={user.user_profile_id}>
            <TableCell>{dayjs(user.date_added).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))}</TableCell>
            <TableCell >{!!user.full_name? user.full_name : ""}</TableCell>
            <TableCell >{!!user.user_name? user.user_name : ""}</TableCell>
            <TableCell>{!!user.status? user.status : ""}</TableCell>
            <TableCell>{!!user.had_incidents_or_losses_details? user.had_incidents_or_losses_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.had_felony_details? user.had_felony_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.declarations_agreement_details? user.declarations_agreement_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.overflights_of_people_details? user.overflights_of_people_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.events_with_large_number_of_people_details? user.events_with_large_number_of_people_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.commercial_operations_by_rpac_pilot_details? user.commercial_operations_by_rpac_pilot_details.split(' ').slice(0, 20).join(' ') : ""}</TableCell>
            <TableCell>{!!user.selected_liability_limit? user.selected_liability_limit : ""}</TableCell>
            <TableCell onClick={(e) => e.stopPropagation()}>
                <IconButton
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                 >
                    { options.map((option) => (
                        <MenuItem key={option.text} onClick={() => onMenuItemClick(option)}>
                            {option.text}
                        </MenuItem>
                    ))}
                </Menu>
            </TableCell>

        </TableRow>
    )
}
